export const mergeLeadUpdate = (previousLead = {}, data = {}, updateData = {}) => ({
  ...previousLead,
  ...data,
  utility:
    updateData.utility !== undefined
      ? { ...(previousLead.utility ?? {}), ...(data.utility ?? {}) }
      : previousLead.utility,
});
